import axios from 'axios';
import { API_BASE_URL } from '@/config';

export const getOrganizations = async () => {
  try {
    const response = await axios.get(API_BASE_URL + '/getOrganizations');
    return response;
  } catch (error) {
    console.error('Error fetching organizations:', error);
  }
};

export const getOrganization = async (id) => {
  const url = id
    ? API_BASE_URL + `/getOrganization?organizationId=${id}`
    : API_BASE_URL + '/getOrganization';
  return await axios.get(url);
};

export const updateOrganization = async (id, formData) => {
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  const response = await axios.put(
    API_BASE_URL + `/admin/organization/${id}`,
    formData,
    {
      headers,
    },
  );
  return response;
};

export const setActiveOrganization = async (id) => {
  const response = await axios.post(
    API_BASE_URL + `/set-active-organization/${id}`,
  );
  return response;
};
